import {
  CaretDownOutlined,
  CaretUpOutlined,
  DownloadOutlined,
  DeleteOutlined,
  LoadingOutlined
} from "@ant-design/icons";
import { Box } from "@strapi/design-system/Box";
import { Flex } from "@strapi/design-system/Flex";
import { IconButton } from "@strapi/design-system/IconButton";
import { Button, Table, Tabs, message } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  exportData,
  getNominators,
  getNominatorsByType,
  getNomineesDeep,
  deleteNominator,
  downloadAttachment
} from "../util/API";
import Nominees from "./Nominees";
import dayjs from "dayjs";

const Secrectariat = () => {
  const { t } = useTranslation();
  const [nominators, setNominators] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [pageSize, setPageSize] = useState(25);
  const [showDetail, setShowDetail] = useState(false);
  const [activeKey, setActiveKey] = useState("1");
  const [nominees, setNominees] = useState([]);
  const [totalNominatorRows, setTotalNominatorRows] = useState(0);
  const [currentNominatorPage, setCurrentNominatorPage] = useState(1);
  const [total, setTotal] = useState(1000);
  const [totalOrgRows, setTotalOrgRows] = useState(0);
  const [currentOrgPage, setCurrentOrgPage] = useState(1);
  const [totalNomineeRows, setTotalNomineeRows] = useState(0);
  const [currentNomineePage, setCurrentNomineePage] = useState(1);
  const [downloading, setDownloading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const handleChangeTab = (key) => {
    setActiveKey(key);
  };

  const fetchNominators = async () => {
    try {
      const response = await getNominatorsByType(
        false,
        currentNominatorPage,
        total
      );
      setNominators(response.data?.data);
      setTotalNominatorRows(response.data?.meta.total || 0);
    } catch (error) {
      console.error(error);
      // TODO: Handle error while fetching profile
    }
  };

  const fetchOrganization = async () => {
    try {
      const response = await getNominatorsByType(
        true,
        currentNominatorPage,
        total
      );

      setOrganizations(response.data?.data);
      setTotalOrgRows(response.data?.meta.total || 0);
    } catch (error) {
      console.error(error);
      // TODO: Handle error while fetching profile
    }
  };

  const getNomineeSelfElected = async () => {
    try {
      const response = await getNomineesDeep();

      if (response.status === 200) {
        const data = response.data?.data;
        setNominees(data);
        setTotalNomineeRows(response.data?.meta.total || 0);
        return data
      }
    } catch (error) {}
  };

  const nominatorColumns = [
    {
      title: `${t("str_ordinal_number")}`,
      key: "index",
      render: (value, record, index) =>
        (currentNominatorPage - 1) * pageSize + index + 1,
    },
    {
      title: `${t("str_nominator_name")}`,
      dataIndex: ["attributes", "name"],
    },
    {
      title: `${t("str_dob")}`,
      dataIndex: ["attributes", "dob"],
    },
    {
      title: `${t("str_phone_number")}`,
      dataIndex: ["attributes", "phone"],
    },
    {
      title: "Email",
      dataIndex: ["attributes", "email"],
    },
    {
      title: "",
      key: "action",
      render: (value, record) => (
        <Flex>
          <Box paddingLeft={1}>
            <IconButton
              onClick={async () => {
                await deleteNominator(record.id);
                fetchNominators();
              }}
              label="Delete"
              noBorder
              icon={<DeleteOutlined />}
            />
          </Box>
        </Flex>
      ),
    },
  ];

  const orgColumns = [
    {
      title: `${t("str_ordinal_number")}`,
      key: "index",
      render: (value, record, index) =>
        (currentOrgPage - 1) * pageSize + index + 1,
    },
    {
      title: `${t("str_nominator_name")}`,
      dataIndex: ["attributes", "name"],
    },
    {
      title: `${t("str_dob")}`,
      dataIndex: ["attributes", "dob"],
    },
    {
      title: `${t("str_phone_number")}`,
      dataIndex: ["attributes", "phone"],
    },
    {
      title: "Email",
      dataIndex: ["attributes", "email"],
    },
    {
      title: "",
      key: "action",
      render: (value, record) => (
        <Flex>
          <Box paddingLeft={1}>
            <IconButton
              onClick={ async () => {
                await deleteNominator(record.id);
                fetchOrganization();
              }}
              label="Delete"
              noBorder
              icon={<DeleteOutlined />}
            />
          </Box>
        </Flex>
      ),
    },
  ];

  const tabItems = [
    {
      key: "1",
      label: `${t("str_org_candidate")}`,
      children: (
        <Table
          rowKey="id"
          columns={orgColumns}
          expandable={{
            // onExpand: (expanded, record) => setSelectedNominee(record),
            expandedRowRender: (record) => (
              <Nominees
                nomineesData={record?.attributes?.nominatees?.data}
                isSecretariatView={true}
              />
            ),
            expandIcon: ({ expanded, onExpand, record }) =>
              expanded ? (
                <CaretUpOutlined onClick={(e) => onExpand(record, e)} />
              ) : (
                <CaretDownOutlined onClick={(e) => onExpand(record, e)} />
              ),
          }}
          dataSource={organizations}
          scroll={{ x: "1000px", y: 480 }}
          pagination={{
            current: currentOrgPage,
            pageSize: pageSize,
            onChange: setCurrentOrgPage,
          }}
        />
      ),
    },
    {
      key: "2",
      label: `${t("str_nominator_candidate")}`,
      children: (
        <Table
          rowKey="id"
          columns={nominatorColumns}
          expandable={{
            // onExpand: (expanded, record) => setSelectedNominee(record),
            expandedRowRender: (record) => (
              <Nominees
                nomineesData={record?.attributes?.nominatees?.data}
                isSecretariatView={true}
              />
            ),
            expandIcon: ({ expanded, onExpand, record }) =>
              expanded ? (
                <CaretUpOutlined onClick={(e) => onExpand(record, e)} />
              ) : (
                <CaretDownOutlined onClick={(e) => onExpand(record, e)} />
              ),
          }}
          dataSource={nominators}
          scroll={{ x: "1000px", y: 480 }}
          pagination={{
            current: currentNominatorPage,
            pageSize: pageSize,
            onChange: setCurrentNominatorPage,
          }}
        />
      ),
    },
    {
      key: "3",
      label: `${t("str_self_candidate")}`,
      children: <Nominees nomineesData={nominees} isSecretariatView={true} getNomineeSelfElected={getNomineeSelfElected} />,
    },
  ];

  useEffect(() => {
    

    fetchNominators();
    fetchOrganization();
    getNomineeSelfElected();
  }, []);

  

  const handleExportData = async () => {
    try {
      const response = await exportData();
      if (response.data.status) {
        const fileName = "nomination_report_" + dayjs().format("x") + ".xlsx";

        const link = document.createElement("a");
        link.href = response.data.url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {}
  };

  const handleDownloadAttachment = async () => {
    setDownloading(true);
    try {
      const response = await downloadAttachment();
      if (response.data.status) {
        setDownloading(false)
        messageApi.open({
          type: "success",
          content: t("str_download_attachment_success"),
        });
      }
    } catch (error) {
      setDownloading(false)
      messageApi.open({
        type: "error",
        content: "Retry",
      });
    }
  };

  return (
    <>
      {!showDetail && (
        <>
          {contextHolder}
          <Flex justifyContent={"end"}>
          <Box paddingBottom={2}>
              <Button icon={downloading ? <LoadingOutlined /> : <DownloadOutlined />} onClick={handleDownloadAttachment}>
                Download Attachments
              </Button>
            </Box>
            <Box paddingBottom={2}>
              <Button icon={<DownloadOutlined />} onClick={handleExportData}>
                Export data
              </Button>
            </Box>
          </Flex>

          <div>
            <Tabs
              defaultActiveKey="1"
              items={tabItems}
              tabPosition="top"
              animated={false}
              onChange={handleChangeTab}
              activeKey={activeKey}
            />
          </div>
        </>
      )}
    </>
  );
};

export default Secrectariat;
